import React from 'react'
import { DisambiguationOption } from '../../../types/helmetLookup'

interface DisambiguationPanelProps {
  watchedHelmetId: string
  disambiguationOptions: (DisambiguationOption & { key: string })[]
  onSelect: (option: DisambiguationOption) => void
}

const DisambiguationPanel: React.FC<DisambiguationPanelProps> = ({
  watchedHelmetId,
  disambiguationOptions,
  onSelect
}) => {
  return (
    <div className="bg-neutral-50 border-l-4 border-warning p-3 sm:p-4 lg:p-6 rounded-lg w-full">
      <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 mb-3 sm:mb-4">
        <div className="bg-warning text-white rounded-full w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center font-bold text-xs sm:text-sm lg:text-base flex-shrink-0">2</div>
        <h3 className="text-base sm:text-lg lg:text-xl font-heading font-bold text-riddell-black">DISAMBIGUATION - MULTIPLE HELMETS FOUND</h3>
      </div>
      <p className="text-riddell-black mb-3 sm:mb-4 text-sm sm:text-base">
        The identifier "{watchedHelmetId}" matches multiple helmets. 
        Please select the correct helmet from the options below:
      </p>
      
      <div className="space-y-2 sm:space-y-3">
        {disambiguationOptions.map((option, index) => (
          <div
            key={option.key}
            className="bg-white border border-neutral-300 rounded-lg p-3 sm:p-4 hover:bg-neutral-50 cursor-pointer transition-colors duration-150"
            onClick={() => onSelect(option)}
          >
            <div className="flex items-start space-x-2 sm:space-x-3">
              <input
                type="radio"
                name="helmetDisambiguation"
                className="mt-1 h-3 w-3 sm:h-4 sm:w-4 text-riddell-red bg-white border-2 border-gray-300 rounded-full focus:ring-2 focus:ring-riddell-red focus:ring-offset-0 transition-all duration-150 flex-shrink-0"
                onChange={() => onSelect(option)}
              />
              <div className="flex-1 min-w-0">
                <div className="font-bold text-riddell-black text-sm sm:text-base lg:text-lg mb-1">{option.organization}</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs sm:text-sm">
                  <div>
                    <span className="text-xs font-bold text-riddell-black uppercase tracking-wide">Player:</span>
                    <div className="text-riddell-black">
                      {option.playerName ? (
                        `${option.playerName}${option.jerseyNumber ? ` (#${option.jerseyNumber})` : ''}`
                      ) : (
                        '[Unassigned]'
                      )}
                    </div>
                  </div>
                  {option.rfidBarcode && (
                    <div>
                      <span className="text-xs font-bold text-riddell-black uppercase tracking-wide">RFID Barcode:</span>
                      <div className="text-riddell-black font-mono text-xs break-all">{option.rfidBarcode}</div>
                    </div>
                  )}
                  <div className="sm:col-span-2">
                    <span className="text-xs font-bold text-riddell-black uppercase tracking-wide">Serial:</span>
                    <div className="text-riddell-black font-mono text-xs break-all">{option.playerUnitSerial}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default DisambiguationPanel
